export const RESET = 'RESET';
export const reset = (finished = false) => ({
    type: RESET,
    payload: {finished}
});

export const SET_SUBMIT_ERROR = 'SET_SUBMIT_ERROR';
export const setSubmitError = error => ({
    type: SET_SUBMIT_ERROR,
    payload: {error}
});

export const SET_SUBMITTING = 'SET_SUBMITTING';
export const setSubmitting = submitting => ({
    type: SET_SUBMITTING,
    payload: {submitting}
});

export const SET_FILTERS = 'SET_FILTERS'
export const setFilters = filters => ({
    type: SET_FILTERS,
    payload: { filters }
})

export const SET_PR_FILTERS = 'SET_PR_FILTERS'
export const setPrFilters = prFilters => ({
    type: SET_PR_FILTERS,
    payload: { prFilters }
})

export const SET_SORT_ASCENDING = 'SET_SORT_ASCENDING'
export const setSortAscending = sortAscending => ({
    type: SET_SORT_ASCENDING,
    payload: { sortAscending }
})

export const SET_SORTING_TYPE = 'SET_SORTING_TYPE'
export const setSortingType = sortingType => ({
    type: SET_SORTING_TYPE,
    payload: { sortingType }
})

export const SET_PR_SORTING_TYPE = 'SET_PR_SORTING_TYPE'
export const setPrSortingType = prSortingType => ({
    type: SET_PR_SORTING_TYPE,
    payload: { prSortingType }
})

export const SET_CR_SORTING_TYPE = 'SET_CR_SORTING_TYPE'
export const setCrSortingType = crSortingType => ({
    type: SET_CR_SORTING_TYPE,
    payload: { crSortingType }
})

export const SET_CR_SECTION = 'SET_CR_SECTION'
export const setCrSection = crSection => ({
    type: SET_CR_SECTION,
    payload: { crSection }
})

export const SET_CR_REPORT_IDS = 'SET_CR_REPORT_IDS'
export const setCrReportIds = crReportIds => ({
    type: SET_CR_REPORT_IDS,
    payload: { crReportIds }
})

export const SET_SURVEY_LANGUAGES = 'SET_SURVEY_LANGUAGES'
export const setSurveyLanguages = surveyLanguages => ({
    type: SET_SURVEY_LANGUAGES,
    payload: { surveyLanguages }
})

export const SET_DRIVERS_VIEWMODE = 'SET_DRIVERS_VIEWMODE'
export const setDriversViewMode = driversViewMode => ({
    type: SET_DRIVERS_VIEWMODE,
    payload: { driversViewMode }
})

export const SET_STATEMENTS_VIEWMODE = 'SET_STATEMENTS_VIEWMODE'
export const setStatementsViewMode = statementsViewMode => ({
    type: SET_STATEMENTS_VIEWMODE,
    payload: { statementsViewMode }
})

export const SET_SHOW_YOUR_RESULTS = 'SET_SHOW_YOUR_RESULTS'
export const setShowYourResults = showYourResults => ({
    type: SET_SHOW_YOUR_RESULTS,
    payload: { showYourResults }
})


// WEBPACK FOOTER //
// ./src/actions/survey.js